<template>
  <div class="px-6 py-20">
    <h2 class="font-bold mb-2">Guild Back Cover</h2>
    <i class="fas fa-info-circle"></i> No preview available for this module.
  </div>
</template>

<script>
export default {
}
</script>
